import _ from "lodash";
import {
  IManhattanOrderState,
  ISetManhattanOrderAction,
  ISetManhattanCheckoutDataAction,
  UpdateOrderItemFullLoaderStatePayload,
} from "./types";
import {
  ChangeDeviceColorRequestData,
  UpdateDeviceColorChangeInProgressPayload,
} from "../types";
import ActionTypes from "../../../../../constants/ActionTypes";
import { IBasketOrderItemAvailableColor } from "../../../../../entities/manhattan/order/types";
import { getFlatStructureOfBasketItems } from "../../../../../utilites/order";

const initialState: IManhattanOrderState = {
  order: {
    basket: {
      ore: null,
      items: [
        {
          type: "",
          items: [],
          subtotal: {
            price: 0,
            checkout: 0,
            installments: 0
          },
        },
      ],
      applicableBenefits: []
    },
    order: {
      referenceId: 0,
    },
    type: "",
  },
  checkoutData: {
    steps: {
      current: {
        type: "",
        step: "",
        data: {},
      },
      next: [],
      previous: [],
    },
  },
  customerInputData: {
    creditCard: {
      id: ""
    },
    modeAddingWallet: false
  },
};

const manhattanOrderReducer = (
  state = initialState,
  action: ISetManhattanOrderAction | ISetManhattanCheckoutDataAction
): any => {
  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.SET_ORDER:
    return {
      ...state,
      order: action.payload,
    };
  case ActionTypes.ORDER.MANHATTAN.SET_CHECKOUT_DATA:
    return {
      ...state,
      checkoutData: action.payload,
    };
  case ActionTypes.ORDER.MANHATTAN.SET_CUSTOMER_INPUT_DATA:
    return {
      ...state,
      customerInputData: { ...state.customerInputData, ...action.payload },
    };
  case ActionTypes.ORDER.MANHATTAN.SET_DEFAULT_CHECKOUT_DATA:
    return {
      ...state,
      checkoutData: {
        steps: {
          current: {
            type: "",
            step: "",
            data: {},
          },
          next: [],
          previous: [],
        },
      },
      customerInputData: {},
    };
  case ActionTypes.ORDER.MANHATTAN.SET_ORE:
    return {
      ...state,
      order: {
        ...state.order,
        basket: {
          ...state.order.basket,
          ore: action.payload
        }
      }
    };
  case ActionTypes.ORDER.MANHATTAN.UPDATE_DEVICE_COLOR:
    const { itemId, colorId } = (action.payload as unknown) as ChangeDeviceColorRequestData;
    const clonedState = _.cloneDeep(state);
    const orderItems = getFlatStructureOfBasketItems(clonedState.order.basket);


    for (const item of orderItems) {
      if (item.id === itemId) {
        item.color = item.availableColors?.find(color => color.colorId === colorId);
        item.imagePath = (item.availableColors?.find(color => color.colorId === colorId) as IBasketOrderItemAvailableColor).img;
      }
    }

    return clonedState;

  case ActionTypes.ORDER.MANHATTAN.UPDATE_COLOR_CHANGE_IN_PROGRESS_STATUS:
    const clonedStateUpdateLoading = _.cloneDeep(state);
    const orderItemsUpdateLoading = getFlatStructureOfBasketItems(clonedStateUpdateLoading.order.basket);


    for (const item of orderItemsUpdateLoading) {
      if (item.id === ((action.payload as unknown) as UpdateDeviceColorChangeInProgressPayload).itemId) {
        item.colorChangeInProgress = ((action.payload as unknown) as UpdateDeviceColorChangeInProgressPayload).colorChangeInProgress;
      }
    }

    return clonedStateUpdateLoading;

  case ActionTypes.ORDER.MANHATTAN.UPDATE_FULL_ITEM_LOADER_STATUS:
    const clonedStateUpdateFullLoading = _.cloneDeep(state);
    const orderItemsFullLoading = getFlatStructureOfBasketItems(clonedStateUpdateFullLoading.order.basket);


    for (const item of orderItemsFullLoading) {
      if (item.id === ((action.payload as unknown) as UpdateOrderItemFullLoaderStatePayload).itemId) {
        item.showFullSizeLoader = ((action.payload as unknown) as UpdateOrderItemFullLoaderStatePayload).status;
      }
    }

    return clonedStateUpdateFullLoading;

  case ActionTypes.ORDER.MANHATTAN.CAN_CONTINUE:
    return {
      ...state,
      checkoutData: {
        ...state.checkoutData,
        steps: {
          ...state.checkoutData.steps,
          current: {
            ...state.checkoutData.steps.current,
            data: {
              ...state.checkoutData.steps.current.data,
              canContinue: action.payload
            }
          }
        }
      }
    };
  }

  return state;
};

export default manhattanOrderReducer;
